import { formatMoney as formatConfiguredMoney } from '../../../utils/decimalValue';

export const formatDashboardMoney = (value: number) =>
  formatConfiguredMoney(value);

export const formatDashboardPercent = (value: number) =>
  new Intl.NumberFormat('es-SV', { maximumFractionDigits: 1 }).format(value) +
  '%';

export const formatDashboardDate = (
  value: string,
  options?: Intl.DateTimeFormatOptions
) => {
  if (!value) return '—';
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? new Date(`${value}T12:00:00`)
    : new Date(value);
  return Number.isNaN(date.getTime())
    ? '—'
    : new Intl.DateTimeFormat(
        'es-SV',
        options ?? { day: '2-digit', month: 'short' }
      ).format(date);
};

export const formatDashboardTime = (value: string) =>
  formatDashboardDate(value, { hour: '2-digit', minute: '2-digit' });

export const formatDashboardDuration = (minutes: number) =>
  `${new Intl.NumberFormat('es-SV', { maximumFractionDigits: 1 }).format(
    minutes
  )} min`;
